module.exports = __webpack_public_path__ + "img/sport-29-@1x.47d95c04.png";